// extracted by mini-css-extract-plugin
export default {"icon":"LabelFile_icon__Jz5P2","inputLabel":"LabelFile_inputLabel__CEa3K","hasDisable":"LabelFile_hasDisable__z8Tmq"};